/* eslint-disable */
import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import withBrands from '../../hoc/withBrands';
import withLocalization from '../../hoc/withLocalization';
import { Modal } from 'react-bootstrap';
import { RootState } from '../../../redux/rootReducer';
import './ParticipationDetails.scss';
import galleryModalCloseLogo from '../../../features/siteTheme/Brands/tmvcs/logo/galleryModalCloseLogo.svg';
import ParseHtml from '../../common/ParseHtml';
interface ImgModalProps {
  localize?: any;
  image?: string;
  closeModal: () => void;
}

const ParticipationDetails: FC<any> = (props: ImgModalProps): ReactElement => {
  const { localize, closeModal } = props;
  const handleKeyDown = () => {};
  const newOfferData: any = useSelector((state: RootState) => state.newOfferDetails.newOfferData);
  const isPinOptFlow: boolean = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFLow);
  const offerDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const offerData: any = (newOfferData?.offers && newOfferData?.offers[0]) || '';
  const pinOfferData: any = (offerDetails?.offers && offerDetails?.offers[0]) || '';
  const detailsOfferContent = offerData?.dopCodeDetails || '';
  const detailsPinOfferContent = pinOfferData?.dopCodeDetails || '';
  const noDopContent = localize('preview-sales-engine.static-content.copy.pbeo.dop-not-available') || '<p><strong>Unable to Display Offer Details</strong></p>\n\n<p> Participation details for this offer are temporarily unavailable</p>';

  const mainContent = isPinOptFlow 
    ? (detailsPinOfferContent || noDopContent)
    : (detailsOfferContent || noDopContent);

  //localize('preview-sales-engine.static-content.copy.pbeo.due-at-booking-label')
  return (
    <div className="modal-overlay-part">
      <div className="modal-part">
        <div className="modal-part-head-container">
          <div className="modal-part-close">
            <input
              className="modal-close-btn"
              src={galleryModalCloseLogo}
              type="image"
              onClick={closeModal}
              aria-label="close"
            />
          </div>
        </div>
        <div className="modal-content-part">
          <ParseHtml htmlInput={mainContent}></ParseHtml>
        </div>
      </div>
    </div>
  );
};
export default React.memo(withLocalization(withBrands(ParticipationDetails)));
